export * from './lib/containers/dossiers-search/components';
export * from './lib/containers/dossiers-search/container';
export * from './lib/containers/dossiers-search/guards';
export * from './lib/containers/dossiers-search/services';
export * from './lib/containers/dossiers-search/store';
export * from './lib/feature-insurer-dossiers-search-routing.module';
